<template>
  <div>
    <v-container grid-list-md v-if="CustomerID._id">
      <!-- {{ CustomerID }} -->
      <v-row class=" justify-space-around">
        <v-col cols="12" md="5" sm="12" lg="5">
          <v-card light class="shape">
            <v-toolbar color="white">
              <!-- <v-btn icon color="black">
                <v-icon>mdi-pen</v-icon>
              </v-btn> -->
              <EditeClient :ClientInfo="CustomerID"></EditeClient>
              <v-toolbar-title>{{ CustomerID.FullName }}</v-toolbar-title>

              <v-spacer></v-spacer>
              <!-- <AddUser :ClientInfo="CustomerID"></AddUser> -->
            </v-toolbar>
            <v-card-text class="black--text subtitle-1">
              <v-row>
                <v-col cols="6"> Phone:</v-col>
                <v-col cols="6">{{ CustomerID.Cusphone }}</v-col>
                <v-col cols="6"> ID Number:</v-col>
                <v-col cols="6">{{ CustomerID.IDNomber }}</v-col>
                <v-col cols="6"> Reg Date:</v-col>
                <v-col cols="6"> {{ CustomerID.RegDate }}</v-col>
                <v-col cols="6"> Share:</v-col>
                <v-col cols="6"> {{ CustomerID.share }}%</v-col>
              </v-row>
            </v-card-text>
            <!-- <v-divider></v-divider> -->
            <v-card-actions class="teal darken-4 justify-center">
              <p v-if="Balance.length === 0">
                {{ EmptyMessage }}
              </p>
              <v-chip-group
                active-class="green white--text"
                v-model="selection"
                center-active
                column
              >
                <template v-for="(item, index) in Balance">
                  <v-chip
                    pill
                    :color="item.Amount < 0 ? '#E57373' : 'white'"
                    text-color="black"
                    active-class="green"
                    light
                    :key="index"
                    >{{ item.Amount.toLocaleString() }}
                    <v-avatar
                      size="avatarSize"
                      :color="item.Amount < 0 ? '#D50000' : '#FFECB3'"
                      class="black--text pa-4 my-4"
                      right
                    >
                      {{ item.AmountType | MoneySigns }}
                    </v-avatar>
                  </v-chip>
                </template>
              </v-chip-group>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="5" sm="12" lg="5">
          <v-card class="shape">
            <v-card-title primary-title class="justify-center headline">
              {{ CustomerID.FullName }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container grid-list-lg>
                <v-row>
                  <v-col cols="12">
                    <deposit
                      :Finished="AffterDeposit"
                      :OwnerID="CustomerID._id"
                    ></deposit>
                  </v-col>
                  <!-- <v-col cols="12">
                    <withdraw
                      :FinishedWithdrow="AffterDeposit"
                      :AccountNumber="CustomerID.AccountNumber"
                    ></withdraw>
                  </v-col>
                  <v-col cols="12">
                    <Exchange
                      :Finished="AffterDeposit"
                      :AccountNumber="CustomerID.AccountNumber"
                    ></Exchange>
                  </v-col> -->
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else grid-list-xs>
      <v-card class="mx-auto mt-10" width="500">
        <v-card-title primary-title>
          Don't refresh again
        </v-card-title>

        <v-card-text class="black--text subtitle-1">
          <!-- <p>{{ CustomerID }}</p> -->
          Refreshing this page will clear the viewing client info
          <v-btn text color="success" to="/owners">Owners List</v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
// import _ from "loadash"
import deposit from "@/components/HQ/Owner/Deposit";
// import withdraw from "@/components/Withdraw";
// import Exchange from "@/components/clientExchange";
// import AddUser from "@/components/AddUser";
import EditeClient from "@/components/HQ/Owner/EditeOwner.vue";
export default {
  components: {
    deposit,
    //  withdraw,
    //  Exchange,
    //  AddUser,
    EditeClient,
  },
  props: ["CustomerID"],
  data() {
    return {
      BaseURL: "/owner",
      selection: -1,
      EmptyMessage: "",
      Balance: [],
    };
  },
  methods: {
    AffterDeposit(amount) {
      if (amount.length > 0) {
        this.selection = -1;
        for (let index = 0; index < this.Balance.length; index++) {
          if (amount[index].Amount != this.Balance[index].Amount) {
            this.selection = index;
            break;
          }
        }
        if (this.selection === -1 && amount.length > this.Balance.length)
          this.selection = amount.length - 1;
        this.Balance = amount;
      }
      //   console.log(amount);
    },
    ShowBalance(item) {
      this.Balance = [];
      this.EmptyMessage = "";
      // console.log(ID);
      this.$store
        .dispatch("FIND_BY_VALUE", {
          url: `${this.BaseURL}/balance`,
          query: {
            _id: item._id,
          },
        })
        .then(result => {
          if (result.data.length === 0)
            this.EmptyMessage = "This Account is Empty";
          // console.log(result);
          if (result.status === 200) {
            this.Balance = result.data;
            // this.Balance.Name = item.FullName;
          }
        })
        .catch(() => {
          this.EmptyMessage = "something is wrong plz try again!!!";
          // console.log(error);
        });
    },
  },
  created() {
    this.ShowBalance(this.CustomerID);
  },
};
</script>
<style scoped>
.shape {
  border-top-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
</style>
